import { render, staticRenderFns } from "./SweetSpotPieChart.vue?vue&type=template&id=1271b9d9&scoped=true"
import script from "./SweetSpotPieChart.vue?vue&type=script&lang=js"
export * from "./SweetSpotPieChart.vue?vue&type=script&lang=js"
import style0 from "./SweetSpotPieChart.vue?vue&type=style&index=0&id=1271b9d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1271b9d9",
  null
  
)

export default component.exports